import React from 'react';
import './Avatar.css';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
/*
props:
    photoURL: the url of the photo of the user
    name: the name of the user
    small: can be true/false. If set to true it is small, otherwise it is big. Defaults to false
    height: is an int, affects the width and height of the image and the size of the text. 40 is default for big and 28 for small
*/

const Avatar = ({photoURL, name,height, small = false, style, fontHeight}) => {

        const hasValidHeight = height && typeof height === 'number' && height > 0;
        
        const imageStyle = hasValidHeight ? {
            height: height + "px",
            width: height + "px",
            borderRadius: height + "px",
            margin: 0,
            flexShrink: 0
        } : {};

        const textStyle = hasValidHeight ? {
            fontSize: Math.floor(fontHeight) + "px"
        } : {};

        return (
            <div className="avatarBg" style={style}>
                {photoURL ? 
                    <img 
                        className={hasValidHeight ? "" : (small ? "avatarPhoto" : "avatarPhotoBig")} 
                        src={photoURL} 
                        alt={name} 
                        style={imageStyle}
                    /> : 
                    <AccountCircleIcon/>
                }
                <div className="avatarText" style={textStyle}>{name}</div>
            </div>
        );

}

export default Avatar;
